import React from "react"
import { ContentBox } from "src/components/Grid"
import { DropdownDownIcon, DropdownUpIcon } from "@infotech/uikit-icons"
import { Box } from "@infotech/uikit-grid"
import { categoryAPI } from "../helpers"
import styles from "./styles.css"

const iconColor = `#adadad`

const CategoryOption = props => {
  const { isExpanded, label, children, onHeaderClick } = props

  const condChildren = isExpanded && children

  const icon = isExpanded ? (
    <DropdownUpIcon color={iconColor} />
  ) : (
    <DropdownDownIcon color={iconColor} />
  )

  return (
    <li>
      <ContentBox
        className={styles.header}
        onClick={onHeaderClick}
        flex
        justify="space-between"
        align="center"
        bb
      >
        {label}
        {icon}
      </ContentBox>
      {condChildren}
    </li>
  )
}

const mapCategoriesToOptions = ({
  categories,
  expandedCategories,
  onGroupClick,
  renderCategoryLabel,
  renderCategoryChildren,
}) =>
  categories.map(category => (
    <CategoryOption
      onHeaderClick={() => onGroupClick(category)}
      key={categoryAPI.getId(category)}
      isExpanded={expandedCategories.some(
        expandedCategory => expandedCategory === category,
      )}
      label={renderCategoryLabel(category)}
    >
      {renderCategoryChildren(category)}
    </CategoryOption>
  ))

export default props => {
  const {
    categories,
    expandedCategories,
    onGroupClick,
    renderCategoryLabel,
    renderCategoryChildren,
  } = props

  return (
    <Box loose className={styles.ConstraintList}>
      <ul className={styles.ListStyles}>
        {mapCategoriesToOptions({
          categories,
          expandedCategories,
          onGroupClick,
          renderCategoryLabel,
          renderCategoryChildren,
        })}
      </ul>
    </Box>
  )
}
